import React from 'react';

export default function ({ highlightsfeed, eleRef }) {
    return (
      <div>
  {eleRef.state.loggedin &&
<section className="main_container_block_feeds baby_view_more">
<div className="main_block_container_feed">
     <div className="block_container_feed_heading_text baby_name_header R15_61">
        <span className="dny-b-15"> {highlightsfeed.data && highlightsfeed.data[0] && highlightsfeed.data[0].childName?highlightsfeed.data[0].childName:''} </span> {highlightsfeed.title?highlightsfeed.title:''}
      </div>
      <div className="baby_grouth-name-section_main uploard-photo-section_main">

          <div className="baby_grouth_names-section">
              <div className="last_baby_gr_pd R13_white"> Last updated on <span className="B13_white"> {highlightsfeed.data && highlightsfeed.data[0] && highlightsfeed.data[0]["date"]?highlightsfeed.data[0]["date"]:''}</span>  </div> 
              <div className="baby_grouth_weight">
                  <div className="grouth_names_babys">
                    <div className="left_grouth_one">
                      <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/ic-weight.png" alt="logo"/>
                    </div>
                    <div className="right_grouth_one">
                       <div className="grouth_weightone R12_white"> Weight </div>
                       <div className="grouth_weight_two"> {highlightsfeed.data && highlightsfeed.data[0] && highlightsfeed.data[0]["wt"]?highlightsfeed.data[0]["wt"]:'0'} Kg</div>
                    </div>
                 </div>
                 <div className="grouth_names_babys">
                    <div className="left_grouth_one">
                      <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/ic-height.png" alt="logo"/>
                    </div>
                    <div className="right_grouth_one">
                       <div className="grouth_weightone R12_white"> Height </div>
                       <div className="grouth_weight_two"> {highlightsfeed.data && highlightsfeed.data[0] && highlightsfeed.data[0]["ht"]?highlightsfeed.data[0]["ht"]:'0'} Cm</div>
                    </div>
                 </div>
                 <div className="grouth_names_babys">
                    <div className="left_grouth_one">
                      <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/ic-head.png" alt="logo"/>
                    </div>
                    <div className="right_grouth_one">
                       <div className="grouth_weightone R12_white"> Height Circ </div>
                       <div className="grouth_weight_two"> {highlightsfeed.data && highlightsfeed.data[0] && highlightsfeed.data[0]["hc"]?highlightsfeed.data[0]["hc"]:'0'} Cm </div>
                    </div>
                 </div>
              </div>
              <div className='rightBabyImg'>
              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/baby-growth-img.png" alt="logo"/>
              </div>
              <div className="idial-head-grouth_height">
              <div className="idial_height_months">
                  <div className="age_yar9"> {highlightsfeed.data && highlightsfeed.data[0]&& highlightsfeed.data[0].age?highlightsfeed.data && highlightsfeed.data[0]&& highlightsfeed.data[0].age:''}</div>
                  <div className="idial_height_months_common">
                      <div className="height_kg_feed">
                        <div className="R12_white"> Ideal Weight </div>
                        <div className="M13_white">{highlightsfeed.data && highlightsfeed.data[0] && highlightsfeed.data[0]["idealminwt"]}-{highlightsfeed.data && highlightsfeed.data[0] &&highlightsfeed.data[0]["idealmaxwt"]} kg </div>
                      </div>
                      <div className="height_kg_feed height_kg_before">
                        <div className="R12_white"> Ideal Height </div>
                        <div className="M13_white"> {highlightsfeed.data && highlightsfeed.data[0] && highlightsfeed.data[0]["idealminht"]}-{highlightsfeed.data && highlightsfeed.data[0] &&highlightsfeed.data[0]["idealmaxht"]} Cm </div>
                      </div>
                      <div className="height_kg_feed height_kg_before">
                        <div className="R12_white"> Ideal Head Circ </div>
                        <div className="M13_white">{highlightsfeed.data && highlightsfeed.data[0] && highlightsfeed.data[0]["idealminhc"]}-{highlightsfeed.data && highlightsfeed.data[0] &&highlightsfeed.data[0]["idealmaxhc"]} Cm </div>
                      </div>
                  </div>
              </div> 
              <div className="baby_grouth-tools-names_view_more">
                 <div className="explore_baby_names">
                  <a href='https://parenting.firstcry.com/tools/child-vaccination-growth-tracker?ref=growthtracker'>
                       <button className="add_grouth_detials" type="button"> Add Growth Details </button>
                       </a>
                  </div>
              </div>
            </div>
          </div>
      </div> 
  </div>
</section>
}
</div>
    )
}
